/**
 * KERIS theme — navigation drawer, countdown, scroll reveals, key figure counters
 */
(function () {
  'use strict';

  function setKerisNavOpen(root, open) {
    if (!root) return;
    var btn = root.querySelector('[data-keris-nav-toggle]');
    var panel = root.querySelector('[data-keris-nav-panel]');
    if (btn) {
      btn.setAttribute('aria-expanded', String(open));
      btn.setAttribute('aria-label', open ? 'Close menu' : 'Menu');
    }
    if (panel) {
      panel.classList.toggle('is-open', open);
      panel.hidden = !open;
      panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    }
    document.body.style.overflow = open ? 'hidden' : '';
  }

  function closeAllKerisNav() {
    document.querySelectorAll('[data-keris-header]').forEach(function (root) {
      var btn = root.querySelector('[data-keris-nav-toggle]');
      if (btn && btn.getAttribute('aria-expanded') === 'true') {
        setKerisNavOpen(root, false);
      }
    });
  }

  function initNav() {
    document.querySelectorAll('[data-keris-header]').forEach(function (root) {
      var panel = root.querySelector('[data-keris-nav-panel]');
      if (panel) {
        panel.setAttribute('aria-hidden', panel.hidden ? 'true' : 'false');
      }
    });

    document.querySelectorAll('[data-keris-nav-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var root = btn.closest('[data-keris-header]');
        if (!root) return;
        var open = btn.getAttribute('aria-expanded') === 'true';
        setKerisNavOpen(root, !open);
      });
    });

    document.querySelectorAll('[data-keris-nav-panel] a').forEach(function (link) {
      link.addEventListener('click', function () {
        var root = link.closest('[data-keris-header]');
        if (!root) return;
        setKerisNavOpen(root, false);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      closeAllKerisNav();
    });
  }

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function initCountdown() {
    var root = document.querySelector('[data-keris-countdown]');
    if (!root) return;
    var targetIso = root.getAttribute('data-target');
    if (!targetIso) return;
    var target = new Date(targetIso).getTime();
    if (Number.isNaN(target)) return;

    function tick() {
      var now = Date.now();
      var diff = Math.max(0, target - now);
      var days = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      var minutes = Math.floor((diff / (1000 * 60)) % 60);
      var seconds = Math.floor((diff / 1000) % 60);
      root.querySelectorAll('[data-unit="days"]').forEach(function (el) {
        el.textContent = pad(days);
      });
      root.querySelectorAll('[data-unit="hours"]').forEach(function (el) {
        el.textContent = pad(hours);
      });
      root.querySelectorAll('[data-unit="minutes"]').forEach(function (el) {
        el.textContent = pad(minutes);
      });
      root.querySelectorAll('[data-unit="seconds"]').forEach(function (el) {
        el.textContent = pad(seconds);
      });
    }

    tick();
    setInterval(tick, 1000);
  }

  function initKerisCartDot() {
    var links = document.querySelectorAll('[data-keris-cart-link]');
    if (!links.length) return;

    function applyCount(n) {
      var c = typeof n === 'number' ? n : 0;
      var has = c > 0;
      links.forEach(function (link) {
        link.classList.toggle('keris-header__link--cart-has-items', has);
      });
    }

    function onCartUpdate(event) {
      var d = event && event.cartData;
      if (d && typeof d.item_count === 'number') {
        applyCount(d.item_count);
      }
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
    }
  }

  function initBackToTop() {
    var btn = document.querySelector('[data-keris-back-to-top]');
    if (!btn) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var threshold = 380;
    function onScroll() {
      var y = window.scrollY || document.documentElement.scrollTop;
      btn.classList.toggle('is-visible', y > threshold);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    btn.addEventListener('click', function () {
      if (reduce) {
        window.scrollTo(0, 0);
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });
  }

  function initReveals() {
    var els = document.querySelectorAll('.keris-reveal');
    if (!els.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    var vh = window.innerHeight || document.documentElement.clientHeight;
    els.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      var inView = rect.top < vh * 0.92 && rect.bottom > 0;
      if (inView) {
        el.classList.add('is-visible');
      } else {
        io.observe(el);
      }
    });
  }

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function initCounters() {
    var blocks = document.querySelectorAll('[data-keris-counter]');
    if (!blocks.length) return;

    function animateOne(block) {
      var target = parseInt(block.getAttribute('data-target'), 10);
      if (isNaN(target)) return;
      var prefix = block.getAttribute('data-prefix') || '';
      var suffix = block.getAttribute('data-suffix') || '';
      if (suffix === 'none') suffix = '';
      var duration = 2000;
      var start = null;

      function frame(now) {
        if (!start) start = now;
        var elapsed = now - start;
        var p = Math.min(elapsed / duration, 1);
        var val = Math.floor(easeOutCubic(p) * target);
        var out = document.createElement('span');
        out.textContent = prefix + val.toLocaleString('en-US') + suffix;
        var slot = block.querySelector('[data-keris-counter-value]');
        if (slot) slot.textContent = out.textContent;
        if (p < 1) requestAnimationFrame(frame);
        else if (slot) slot.textContent = prefix + target.toLocaleString('en-US') + suffix;
      }
      requestAnimationFrame(frame);
    }

    if (!('IntersectionObserver' in window)) {
      blocks.forEach(animateOne);
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animateOne(entry.target);
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.35 }
    );
    blocks.forEach(function (b) {
      io.observe(b);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initNav();
      initCountdown();
      initKerisCartDot();
      initBackToTop();
      initReveals();
      initCounters();
    });
  } else {
    initNav();
    initCountdown();
    initKerisCartDot();
    initBackToTop();
    initReveals();
    initCounters();
  }
})();
